<template>
	<div>
		<h1>Alapadat-beviteli felület</h1>
    <v-tabs
      v-model="aktivtab"
      color="primary"
      icons-and-text
			v-if="admin!={}"
    >
      <v-tab>Felhasználók<v-icon>fa-user</v-icon></v-tab>
      <v-tab>Csoportok<v-icon>fa-users</v-icon></v-tab>
      <v-tab>Szobák<v-icon>fa-bed</v-icon></v-tab>
      <v-tab>Szilenciumok<v-icon>fa-business-time</v-icon></v-tab>
			<v-tab>Termek<v-icon>fa-chalkboard-teacher</v-icon></v-tab>
      <v-tab>Minősítések<v-icon>fa-star</v-icon></v-tab>
			<v-tab>Szakkörök<v-icon>fa-lightbulb</v-icon></v-tab>
			<v-tab>Szobapontozási szempontok<v-icon>fa-broom</v-icon></v-tab>
			<v-tab>Vonalkódok<v-icon>fa-barcode</v-icon></v-tab>
			<v-tab>Vonalkódolvasó-állomások<v-icon>fa-eye</v-icon></v-tab>
      <v-tab-item><!--Felhasználók-->
        <v-data-table
          :headers="tablazatok.felhasznalok.fejlec"
          :items="admin.felhasznalok.map(f => {
						return {
							...f,
							vonalkod: admin.vonalkodok.findIndex(vk => vk.tanuloid==f.id)!=-1||f.minosites<0
						}
						})"
          multi-sort
          show-group-by
          sort-by="nev"
          :search="tablazatok.felhasznalok.kereses"
        >
          <template v-slot:top>
						<v-row>
							<v-col cols="12" sm="10">
								<v-text-field
		              v-model="tablazatok.felhasznalok.kereses"
		              label="Keresés"
		              prepend-inner-icon="fa-search"
		            ></v-text-field>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top>
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="info" @click="dialogusok.ujfelhasznalo.mutat=true"><v-icon>fa-user-plus</v-icon></v-btn>
									</template>
									Felhasználó hozzáadása
								</v-tooltip>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top>
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="warning" @click="dialogusok.felhasznalokimportalasa.mutat=true"><v-icon>fa-file-excel</v-icon></v-btn>
									</template>
									Felhasználók importálása Excel(.xlsx) fájlból
								</v-tooltip>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
          </template>
					<template v-slot:group.header="{ group, headers, toggle, isOpen, groupBy, remove }">
					  <td :colspan="headers.length">
							<v-tooltip top>
								<template v-slot:activator="{on, attrs}">
									<v-btn @click="toggle" x-small icon v-on="on" v-bind="attrs" :ref="group">
	 					         <v-icon v-if="isOpen">fa-minus</v-icon>
	 					         <v-icon v-else>fa-plus</v-icon>
	 					     </v-btn>
								</template>
								{{isOpen ? "Összecsukás" : "Kinyitás"}}
							</v-tooltip>

							 <v-icon v-if="groupBy=='minosites'">fa-star</v-icon>
							 <v-icon v-if="groupBy=='csoportid'">fa-users</v-icon>
					     <span class="mx-5 font-weight-bold" v-if="groupBy=='minosites'">{{"Minősítés: "+admin.minositesek.find(m=> m.id==group).minositesnev}}</span>
							 <span class="mx-5 font-weight-bold" v-else-if="groupBy=='csoportid'">{{""+group ? admin.csoportok.find(cs => cs.id==group).csoportnev : "Csoportosítatlanok"}}</span>
							 <span class="mx-5 font-weight-bold" v-else>{{groupBy+": "+group}}</span>
							 <v-tooltip top>
								 <template v-slot:activator="{on, attrs}">
									 <v-btn icon @click="remove" v-bind="attrs" v-on="on"><v-icon>fa-times</v-icon></v-btn>
								 </template>
								 A csoportosítás megszüntetése
							 </v-tooltip>
					  </td>
					</template>
					<template v-slot:item.nev="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(0,props.item.id,0)"
							@open="modositottertek=props.item.nev"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{props.item.nev}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Szerkesztés"
									single-line
									autofocus
									prepend-inner-icon="fa-sign-alt"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.email="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(0,props.item.id,1)"
							@open="modositottertek=props.item.email"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{props.item.email}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Szerkesztés"
									single-line
									autofocus
									prepend-inner-icon="fa-envelope"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
          <template v-slot:item.minosites="{ item }">
						<v-edit-dialog
							large
							persistent
							@save="modositas(0,item.id,2)"
							@open="modositottertek=item.minosites"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{admin.minositesek.find(m => m.id==item.minosites).minositesnev}}</div>
							<template v-slot:input>
								<v-select
									v-model="modositottertek"
									label="Minősítés"
									prepend-icon="fa-star"
									:items="admin.minositesek"
									item-text="minositesnev"
									item-value="id"
									rounded
									outlined
								></v-select>
							</template>
						</v-edit-dialog>

          </template>
					<template v-slot:item.vonalkod="props">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn v-on="on" v-bind="attrs" :color="props.item.vonalkod ? 'success' : 'red accent-4'"><v-icon>fa-barcode</v-icon></v-btn>
							</template>
							{{props.item.vonalkod ? "A felhasználó vonalkódja rendben van." : "A felhasználó vonalkódja hiányzik."}}
						</v-tooltip>
					</template>
					<template v-slot:item.csoportid="{ item }">
						<v-edit-dialog
							v-if="item.minosites>=0"
							large
							persistent
							@save="csoporthozrendeles(item.id,modositottertek)"
							@open="modositottertek=item.csoportid"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.csoportid ? admin.csoportok.find(cs => cs.id==item.csoportid).csoportnev : "-"}}</div>

							<template v-slot:input >
								<v-select
									v-model="modositottertek"
									label="Csoport"
									prepend-icon="fa-users"
									:items="admin.csoportok"
									item-text="csoportnev"
									item-value="id"
									rounded
									outlined
								></v-select>
							</template>
						</v-edit-dialog>
						<div v-else>Dolgozó</div>
          </template>
					<template v-slot:item.szobaid="{ item }">
						<v-edit-dialog
							v-if="item.minosites>=0"
							large
							persistent
							@save="szobahozrendeles(item.id,modositottertek)"
							@open="modositottertek=item.szobaid"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.szobaid ? admin.szobak.find(sz => sz.id==item.szobaid).szobanev : "-"}}</div>
							<template v-slot:input>
								<v-select
									v-model="modositottertek"
									label="Szoba"
									prepend-icon="fa-bed"
									:items="admin.szobak"
									item-text="szobanev"
									item-value="id"
									rounded
									outlined
								></v-select>
							</template>
						</v-edit-dialog>
						<div v-else>Dolgozó</div>
          </template>
          <template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn v-if="admin.csoportok.findIndex(cs =>cs.csoportvezetoid==item.id)==-1" icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(0,item.id)"><v-icon>fa-trash</v-icon></v-btn>
								<v-btn v-else icon depressed v-bind="attrs" v-on="on" color=""><v-icon>fa-trash</v-icon></v-btn>
							</template>
							{{admin.csoportok.findIndex(cs =>cs.csoportvezetoid==item.id)==-1 ? "Törlés" : "Nem törölhető, mert csoportvezető"}}
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon v-bind="attrs" v-on="on" color="info" @click="dialogusok.jelszovaltoztato.felhasznaloid=item.id,dialogusok.jelszovaltoztato.mutat=true"><v-icon>fa-key</v-icon></v-btn>
							</template>
							Jelszó módosítása
						</v-tooltip>
          </template>

        </v-data-table>

      </v-tab-item><!--Felhasználók-->

      <v-tab-item><!--Csoportok-->
				<v-data-table
					:headers="tablazatok.csoportok.fejlec"
					:items="admin.csoportok"
					sort-by="csoportnev"
					:search="tablazatok.csoportok.kereses"
				>
					<template v-slot:top>
						<v-row>
							<v-col cols="12" sm="11">
								<v-text-field
									v-model="tablazatok.csoportok.kereses"
									label="Keresés"
									prepend-inner-icon="fa-search"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top>
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="info" @click="dialogusok.ujcsoport.mutat=true"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Csoport hozzáadása
								</v-tooltip>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
					</template>
					<template v-slot:item.csoportnev="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(1,props.item.id,0)"
							@open="modositottertek=props.item.csoportnev"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{props.item.csoportnev}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Szerkesztés"
									single-line
									autofocus
									prepend-inner-icon="fa-users"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.csoportvezeto="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(1,props.item.id,1)"
							@open="modositottertek=props.item.csoportvezetoid"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{admin.felhasznalok.find(f => f.id==props.item.csoportvezetoid).nev}}</div>
							<template v-slot:input>
								<v-select
									v-model="modositottertek"
									:items="admin.felhasznalok.filter(f=> f.minosites<0 && (admin.csoportok.filter(cs => cs.csoportvezetoid==f.id).length==0 || f.id==props.item.csoportvezetoid))"
									item-text="nev"
									item-value="id"
									prepend-icon="fa-chalkboard-teacher"
									label="Csoportvezető"
									rounded
									outlined
								></v-select>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.letszam="{item}">
						{{admin.felhasznalok.filter(f => f.csoportid==item.id).length}} fő
					</template>
					<template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(1,item.id)"><v-icon>fa-trash</v-icon></v-btn>
							</template>
							Törlés
						</v-tooltip>
					</template>
				</v-data-table>

      </v-tab-item><!--Csoportok-->

      <v-tab-item><!--Szobák-->
				<v-data-table
					:headers="tablazatok.szobak.fejlec"
					:items="admin.szobak"
					sort-by="szobanev"
					:search="tablazatok.szobak.kereses"
				>
					<template v-slot:top>
						<v-row>
							<v-col cols="12" sm="11">
								<v-text-field
									v-model="tablazatok.szobak.kereses"
									label="Keresés"
									prepend-inner-icon="fa-search"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top>
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="info" @click="dialogusok.ujszoba.mutat=true"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Szoba hozzáadása
								</v-tooltip>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
					</template>
					<template v-slot:item.szobanev="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(2,props.item.id,0)"
							@open="modositottertek=props.item.szobanev"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{props.item.szobanev}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Szerkesztés"
									single-line
									autofocus
									prepend-inner-icon="fa-bed"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.tanulok="{item}">
						<v-edit-dialog
							large
							persistent
							@save="szobahozrendeles(tablazatok.szobak.szobahoztanuloid,item.id)"
							cancel-text="Mégsem"
							save-text="Hozzáadás"
						>
							<v-chip color="primary" close @click:close="szobaboltorles(tanulo.id)" v-for="tanulo in admin.felhasznalok.filter(f => f.szobaid==item.id)" :key="Vfrissites">{{tanulo.nev+(tanulo.csoportid? (" - "+admin.csoportok.find(cs => cs.id==tanulo.csoportid).csoportnev):"")}}</v-chip>
							<template v-slot:input>
								Tanuló hozzáadása
								<v-select
									v-model="tablazatok.szobak.szobahoztanuloid"
									label="Tanuló"
									prepend-inner-icon="fa-user"
									rounded
									outlined
									:items="admin.felhasznalok.filter(f => f.szobaid==null && f.minosites>=0)"
									item-text="nev"
									item-value="id"
								>

								</v-select>
							</template>
						</v-edit-dialog>

					</template>
					<template v-slot:item.letszam="{item}">
						{{admin.felhasznalok.filter(f => f.szobaid==item.id).length}} fő
					</template>
					<template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(2,item.id)"><v-icon>fa-trash</v-icon></v-btn>
							</template>
							Törlés
						</v-tooltip>
					</template>

				</v-data-table>
      </v-tab-item><!--Szobák-->

      <v-tab-item><!--Szilenciumok-->
				<v-data-table
          :headers="tablazatok.szilenciumok.fejlec"
          :items="admin.szilenciumok"
          sort-by="szam"
					show-expand
					single-expand
        >

          <template v-slot:top>
						<v-row>
							<v-col cols="12" sm="2">
								<h1>Új szilencium</h1>
							</v-col>
							<v-col cols="12" sm="2">
								<v-text-field
									v-model="dialogusok.ujszilencium.szam"
									label="Sorszám"
									rounded
									outlined
									prepend-inner-icon="fa-business-time"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="4">
								<v-text-field
									v-model="dialogusok.ujszilencium.idopont"
									label="Időpont"
									rounded
									outlined
									prepend-inner-icon="fa-clock"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="3">
								<v-text-field
									v-model="dialogusok.ujszilencium.letszamkorlat"
									label="Létszámkorlát"
									rounded
									outlined
									prepend-inner-icon="fa-user-check"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top v-if="dialogusok.ujszilencium.szam>0&&dialogusok.ujszilencium.idopont&&dialogusok.ujszilencium.letszamkorlat>0">
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujszilencium()"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Szilencium hozzáadása
								</v-tooltip>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
          </template>
					<template v-slot:expanded-item="{headers, item}">
            <td :colspan="headers.length">
              <v-data-table
                :headers="tablazatok.szilenciumok.termek.fejlec"
                hide-default-footer
                disable-pagination
                sort-by="nev"
                multi-sort
								:items="item.termek"
								:key="tablazatok.szilenciumok.termek.key"
              >
                <template v-slot:top>
									<v-row>
										<v-col cols="12" sm="3">
											<h1>Terem hozzáadása</h1>
										</v-col>
										<v-col cols="12" sm="8">
											<v-select
												rounded
												outlined
												prepend-inner-icon="fa-chalkboard-teacher"
												label="Terem"
												:items="admin.termek.filter(t => !admin.terem_szilencium.find(tsz => tsz.teremid==t.id&&tsz.szilenciumid==item.id)).map(t => {
													return {
														text: t.nev,
														value: t.id
													}
													})"
												v-model="dialogusok.teremHozzarendeleseSzilenciumhoz.teremid"
											/>
										</v-col>
										<v-col cols="12" sm="1">
											<v-tooltip top v-if="dialogusok.teremHozzarendeleseSzilenciumhoz.teremid!==null">
		                    <template v-slot:activator="{on, attrs}">
		                      <v-btn fab right v-on="on" color="primary"  v-bind="attrs" @click="teremHozzarendeleseSzilenciumhoz(dialogusok.teremHozzarendeleseSzilenciumhoz.teremid,item.id)"><v-icon>fa-chalkboard-teacher</v-icon></v-btn>
		                    </template>
		                    Terem hozzáadása szilenciumhoz
		                  </v-tooltip>
										</v-col>
									</v-row>
                </template>
								<template v-slot:item.muveletek="props">
									<v-tooltip top>
										<template v-slot:activator="{on, attrs}">
											<v-btn icon v-bind="attrs" v-on="on" color="red accent-4" @click="teremTorleseSzilenciumtol(props.item.id, item.id)"><v-icon>fa-trash</v-icon></v-btn>
										</template>
										Törlés
									</v-tooltip>
								</template>
              </v-data-table>
            </td>
          </template>

					<template v-slot:item.szam="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(3,props.item.id,0)"
							@open="modositottertek=props.item.szam"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{props.item.szam}}.</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Sorszám"
									single-line
									autofocus
									prepend-inner-icon="fa-business-time"
									rounded
									outlined
									suffix=". szilencium"
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.idopont="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(3,props.item.id,1)"
							@open="modositottertek=props.item.idopont"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{props.item.idopont}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Időpont"
									single-line
									autofocus
									prepend-inner-icon="fa-clock"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
          <template v-slot:item.letszamkorlat="{ item }">
						<v-edit-dialog
							large
							persistent
							@save="modositas(3,item.id,2)"
							@open="modositottertek=item.letszamkorlat"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.letszamkorlat}} fő</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Létszámkorlát"
									prepend-inner-icon="fa-user-check"
									rounded
									outlined
									suffix="fő"
								></v-text-field>
							</template>
						</v-edit-dialog>

          </template>

          <template v-slot:item.muveletek="{ item }">
						<v-tooltip top v-if="admin.csoportok.findIndex(cs =>cs.csoportvezetoid==item.id)==-1">
							<template v-slot:activator="{on, attrs}">
								<v-btn icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(3,item.id)"><v-icon>fa-trash</v-icon></v-btn>
							</template>
							Törlés
						</v-tooltip>
          </template>

        </v-data-table>

      </v-tab-item><!--Szilenciumok-->
			<v-tab-item><!--Termek-->
				<v-data-table
          :headers="tablazatok.termek.fejlec"
          :items="admin.termek"
          sort-by="nev"
        >
				<template v-slot:top>
					<v-row>
						<v-col cols="12" sm="2">
							<h1>Új terem</h1>
						</v-col>
						<v-col cols="12" sm="2">
							<v-text-field
								v-model="dialogusok.ujterem.nev"
								label="Név"
								rounded
								outlined
								prepend-inner-icon="fa-chalkboard-teacher"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="4">
							<v-text-field
								v-model="dialogusok.ujterem.ferohely"
								label="Férőhely"
								rounded
								outlined
								prepend-inner-icon="fa-user-check"
								suffix="Fő"
							></v-text-field>
						</v-col>
						<v-col cols="12" sm="1">
							<v-tooltip top v-if="dialogusok.ujterem.nev&&dialogusok.ujterem.ferohely">
								<template v-slot:activator="{on, attrs}">
									<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujterem()"><v-icon>fa-plus</v-icon></v-btn>
								</template>
								Terem hozzáadása
							</v-tooltip>
						</v-col>
					</v-row>
					<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
				</template>

				<template v-slot:item.nev="props">
					<v-edit-dialog
						large
						persistent
						@save="modositas(7,props.item.id,0)"
						@open="modositottertek=props.item.szam"
						cancel-text="Mégsem"
						save-text="Mentés"
					>
						<div>{{props.item.nev}}</div>
						<template v-slot:input>
							<v-text-field
								v-model="modositottertek"
								label="Név"
								single-line
								autofocus
								prepend-inner-icon="fa-chalkboard-teacher"
								rounded
								outlined
							></v-text-field>
						</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.ferohely="{ item }">
					<v-edit-dialog
						large
						persistent
						@save="modositas(7,item.id,1)"
						@open="modositottertek=item.ferohely"
						cancel-text="Mégsem"
						save-text="Mentés"
					>
						<div>{{item.ferohely}} fő</div>
						<template v-slot:input>
							<v-text-field
								v-model="modositottertek"
								label="Férőhely"
								prepend-inner-icon="fa-user-check"
								rounded
								outlined
								suffix="fő"
							></v-text-field>
						</template>
					</v-edit-dialog>

				</template>

				<template v-slot:item.muveletek="{ item }">
					<v-tooltip top>
						<template v-slot:activator="{on, attrs}">
							<v-btn icon v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(9,item.id)"><v-icon>fa-trash</v-icon></v-btn>
						</template>
						Törlés
					</v-tooltip>
				</template>

			</v-data-table>


			</v-tab-item>
      <v-tab-item><!--Minősítések-->
				<v-data-table
          :headers="tablazatok.minositesek.fejlec"
          :items="admin.minositesek.filter(m => m.id>=0)"
          sort-by="minositesnev"
					v-if="admin.minositesek"
        >
          <template v-slot:top>
						<v-row>
							<v-col cols="12" sm="2">
								<h1>Új minősítés</h1>
							</v-col>
							<v-col cols="12" sm="3">
								<v-text-field
									v-model="dialogusok.ujminosites.minositesnev"
									label="Minősítés"
									rounded
									outlined
									prepend-inner-icon="fa-star"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="2">
								<v-checkbox v-model="dialogusok.ujminosites.szilenciumvalasztas" false-value="0" true-value="1" label="Szilenciumválasztásra kötelezett" prepend-icon="fa-user-check"></v-checkbox>
							</v-col>
							<v-col cols="12" sm="2">
								<v-checkbox v-model="dialogusok.ujminosites.szilenciumiletszambaszamit" false-value="0" true-value="1" label="Szilenciumi létszámba számít" prepend-icon="fa-users"></v-checkbox>
							</v-col>
							<v-col sols="12" sm="2">
								<v-text-field
									v-model="dialogusok.ujminosites.valasztandoszilencium"
									label="Választandó szilenciumok száma"
									rounded
									outlined
									prepend-inner-icon="fa-business-time"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top v-if="dialogusok.ujminosites.minositesnev">
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujminosites()"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Minősítés hozzáadása
								</v-tooltip>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
          </template>

					<template v-slot:item.minositesnev="{item}">
						<v-edit-dialog
							large
							persistent
							@save="modositas(4,item.id,0)"
							@open="modositottertek=item.minositesnev"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.minositesnev}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Minősítés"
									single-line
									autofocus
									prepend-inner-icon="fa-star"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.letszam="{ item }">
						{{admin.felhasznalok.filter(f => f.minosites==item.id).length}} fő

          </template>
					<template v-slot:item.szilenciumvalasztas="{item}">
						<v-checkbox  readonly  v-model="item.szilenciumvalasztas" @click="modositottertek = item.szilenciumvalasztas ? 0 : 1 ,modositas(4,item.id,1)"></v-checkbox>
					</template>
          <template v-slot:item.szilenciumiletszambaszamit="{ item }">
							<v-checkbox readonly v-model="item.szilenciumiletszambaszamit" @click="modositottertek = item.szilenciumiletszambaszamit ? 0 : 1 ,modositas(4,item.id,2)"></v-checkbox>
          </template>

					<template v-slot:item.valasztandoszilencium="{item}">
						<v-edit-dialog
							large
							persistent
							@save="modositas(4,item.id,3)"
							@open="modositottertek=item.valasztandoszilencium"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.valasztandoszilencium}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Minősítés"
									single-line
									autofocus
									prepend-inner-icon="fa-star"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>

          <template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon v-if="admin.felhasznalok.findIndex(f =>f.minosites==item.id)==-1&&item.id>0" v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(4,item.id)"><v-icon>fa-trash</v-icon></v-btn>
								<v-btn icon v-else v-bind="attrs" v-on="on" depressed><v-icon>fa-trash</v-icon></v-btn>
							</template>
							{{admin.felhasznalok.findIndex(f =>f.minosites==item.id)==-1 ? "Törlés" : "Nem törölhető, mert valamelyik felhasználónak ilyen minősítése van."}}
						</v-tooltip>
          </template>

        </v-data-table>
      </v-tab-item><!--Minősítések-->
			<v-tab-item><!--Szakkörök-->
				<v-data-table
          :headers="tablazatok.szakkorok.fejlec"
          :items="admin.szakkorok"
          sort-by="szakkornev"
        >
          <template v-slot:top>
						<v-row>
							<v-col cols="12" sm="2">
								<h1 align="right">Új szakkör</h1>
							</v-col>
							<v-col cols="12" sm="3">
								<v-text-field
									v-model="dialogusok.ujszakkor.szakkornev"
									label="Szakkör"
									rounded
									outlined
									prepend-inner-icon="fa-lightbulb"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="3">
								<v-select
									v-model="dialogusok.ujszakkor.szakkorvezetoid"
									:items="admin.felhasznalok.filter(f=> f.minosites<0)"
									item-text="nev"
									item-value="id"
									prepend-icon="fa-chalkboard-teacher"
									rounded
									label="Szakkörvezető"
									outlined
								></v-select>
							</v-col>
							<v-col cols="12" sm="3">
								<v-text-field
									v-model="dialogusok.ujszakkor.idoponteshely"
									label="Időpontja és helye"
									rounded
									outlined
									prepend-inner-icon="fa-clock"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top v-if="dialogusok.ujszakkor.szakkornev&&dialogusok.ujszakkor.szakkorvezetoid>-1&&dialogusok.ujszakkor.idoponteshely">
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujszakkor()"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Szakkör hozzáadása
								</v-tooltip>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
          </template>

					<template v-slot:item.szakkornev="{item}">
						<v-edit-dialog
							large
							persistent
							@save="modositas(5,item.id,0)"
							@open="modositottertek=item.szakkornev"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.szakkornev}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Szakkör"
									single-line
									autofocus
									prepend-inner-icon="fa-lightbulb"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.szakkorvezeto="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(5,props.item.id,1)"
							@open="modositottertek=props.item.szakkorvezetoid"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{admin.felhasznalok.find(f => f.id==props.item.szakkorvezetoid).nev}}</div>
							<template v-slot:input>
								<v-select
									v-model="modositottertek"
									:items="admin.felhasznalok.filter(f=> f.minosites<0)"
									item-text="nev"
									item-value="id"
									prepend-icon="fa-chalkboard-teacher"
									rounded
									label="Szakkörvezető"
									outlined
								></v-select>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.idoponteshely="{item}">
						<v-edit-dialog
							large
							persistent
							@save="modositas(5,item.id,2)"
							@open="modositottertek=item.idoponteshely"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.idoponteshely}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Időpontja és helye"
									single-line
									autofocus
									prepend-inner-icon="fa-clock"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
          <template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon  v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(5,item.id)"><v-icon>fa-trash</v-icon></v-btn>
							</template>
							Törlés
						</v-tooltip>
          </template>

        </v-data-table>
			</v-tab-item><!--Szakkörök-->
			<v-tab-item><!--Szobapontozás-->
				<v-data-table
          :headers="tablazatok.szobapontozasiszempontok.fejlec"
          :items="admin.szobapontozasiszempontok"
          sort-by="szempont"
        >
          <template v-slot:top>
						<v-row>
							<v-col cols="12" sm="2">
								<h1 align="right">Új szempont</h1>
							</v-col>
							<v-col cols="12" sm="3">
								<v-text-field
									v-model="dialogusok.ujszobapontozasiszempont.szempont"
									label="Szempont"
									rounded
									outlined
									prepend-inner-icon="fa-broom"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="3">
								<v-text-field
									v-model="dialogusok.ujszobapontozasiszempont.leiras"
									label="Leírás"
									rounded
									outlined
									prepend-inner-icon="fa-font"></v-text-field>
							</v-col>
							<v-col cols="12" sm="3">
								<v-slider
									v-model="dialogusok.ujszobapontozasiszempont.pont"
									thumb-label="always"
									prepend-icon="fa-star"
									max="5"
									min="-5"
									label="Pont"
								></v-slider>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top v-if="dialogusok.ujszobapontozasiszempont.szempont">
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujszobapontozasiszempont()"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Szempont hozzáadása
								</v-tooltip>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
          </template>

					<template v-slot:item.szempont="{item}">
						<v-edit-dialog
							large
							persistent
							@save="modositas(6,item.id,0)"
							@open="modositottertek=item.szempont, tablazatok.szobapontozasiszempontok.pontmodositas=false"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.szempont}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Szempont"
									single-line
									autofocus
									prepend-inner-icon="fa-broom"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.leiras="props">
						<v-edit-dialog
							large
							persistent
							@save="modositas(6,props.item.id,1)"
							@open="modositottertek=props.item.leiras, tablazatok.szobapontozasiszempontok.pontmodositas=false"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{props.item.leiras}}</div>
							<template v-slot:input>
								<v-text-field
									v-model="modositottertek"
									label="Leírás"
									single-line
									autofocus
									prepend-inner-icon="fa-font"
									rounded
									outlined
								></v-text-field>
							</template>
						</v-edit-dialog>
					</template>
					<template v-slot:item.pont="{item}">
						<v-edit-dialog
							large
							persistent
							@save="modositas(6,item.id,2)"
							@open="modositottertek=item.pont, tablazatok.szobapontozasiszempontok.pontmodositas=true"
							cancel-text="Mégsem"
							save-text="Mentés"
						>
							<div>{{item.pont}}</div>
							<template v-slot:input>
								<v-slider
									v-if="tablazatok.szobapontozasiszempontok.pontmodositas&&aktivtab==6"
									v-model="modositottertek"
									thumb-label="always"
									prepend-icon="fa-star"
									max="5"
									min="-5"
									label="Pont"
								></v-slider>
							</template>
						</v-edit-dialog>
					</template>
          <template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon  v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(6,item.id)"><v-icon>fa-trash</v-icon></v-btn>
							</template>
							Törlés
						</v-tooltip>
          </template>

        </v-data-table>
			</v-tab-item>
			<v-tab-item><!--Vonalkódok-->
				<v-data-table
					:headers="tablazatok.vonalkodok.fejlec"
					:items="admin.vonalkodok.map(vk => {
						return {
							vonalkod: vk.vonalkod,
							tanulo: (() => { const f = admin.felhasznalok.find(f =>f.id==vk.tanuloid); return f ? f.nev: '-'})()
						}
						})"
					sort-by="tanulo"
					:search="tablazatok.vonalkodok.kereses"
					show-group-by
					v-if="admin.vonalkodok"
				>
					<template v-slot:top>
						<v-row>
							<v-col cols="12" sm="2">
								<h1 align="right">Új vonalkód</h1>
							</v-col>
							<v-col cols="12" sm="4">
								<v-text-field
									v-model="dialogusok.ujvonalkod.vonalkod"
									label="Vonalkód"
									rounded
									outlined
									prepend-inner-icon="fa-barcode"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="4">
								<v-select
									v-model="dialogusok.ujvonalkod.tanuloid"
									:items="admin.felhasznalok.filter(f=> f.minosites>=0).map(f => {
										return {
											id: f.id,
											nev: f.nev+(f.csoportid? (' ('+admin.csoportok.find(cs => cs.id==f.csoportid).csoportnev+')'):'')
										}
										})"
									item-text="nev"
									item-value="id"
									prepend-icon="fa-user"
									rounded
									label="Tanuló"
									outlined
								></v-select>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top v-if="dialogusok.ujvonalkod.vonalkod&&dialogusok.ujvonalkod.tanuloid>-1">
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujvonalkod()"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Vonalkód hozzáadása
								</v-tooltip>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="tablazatok.vonalkodok.kereses"
									label="Keresés"
									prepend-inner-icon="fa-search"
								></v-text-field>
							</v-col>
						</v-row>
						<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
					</template>
					<template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon  v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(7,item.vonalkod)"><v-icon>fa-trash</v-icon></v-btn>
							</template>
							Törlés
						</v-tooltip>
					</template>

				</v-data-table>
			</v-tab-item><!--Vonalkódok-->
			<v-tab-item><!--Vonalkódolvasó állomások-->
				<v-data-table
					:headers="tablazatok.vonalkodolvasoallomasok.fejlec"
					:items="admin.vonalkodolvasoallomasok"
					sort-by="allomasnev"
					show-group-by
					v-if="admin.vonalkodolvasoallomasok"
				>
					<template v-slot:top>
						<v-row>
							<v-col cols="12" sm="2">
								<h1 align="right">Új állomás</h1>
							</v-col>
							<v-col cols="12" sm="4">
								<v-text-field
									v-model="dialogusok.ujvonalkodolvasoallomas.allomasnev"
									label="Állomásnév"
									rounded
									outlined
									prepend-inner-icon="fa-eye"
								></v-text-field>
							</v-col>
							<v-col cols="12" sm="1">
								<v-tooltip top v-if="dialogusok.ujvonalkodolvasoallomas.allomasnev">
									<template v-slot:activator="{on, attrs}">
										<v-btn fab v-bind="attrs" v-on="on" color="success" @click="ujvonalkodolvasoallomas()"><v-icon>fa-plus</v-icon></v-btn>
									</template>
									Állomás hozzáadása
								</v-tooltip>
							</v-col>
							<v-col cos="12" sm="5">
								<v-checkbox v-model="dialogusok.torlesmegerosito.megerositesnelkul" label="Törlés megerősítés nélkül"></v-checkbox>
							</v-col>
						</v-row>

					</template>
					<template v-slot:item.feladat="{item}">
						<div v-if="item.feladat==-1">Be- és kiléptetés</div>
					</template>
					<template v-slot:item.muveletek="{ item }">
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon  v-bind="attrs" v-on="on" color="red accent-4" @click="torlesdialogus(8,item.id)"><v-icon>fa-trash</v-icon></v-btn>
							</template>
							Törlés
						</v-tooltip>
						<v-tooltip top>
							<template v-slot:activator="{on, attrs}">
								<v-btn icon v-bind="attrs" v-on="on" color="primary" @click="ujtitkoskulcs(item.id)"><v-icon>fa-key</v-icon></v-btn>
							</template>
							Új titkos kulcs generálása
						</v-tooltip>
					</template>

				</v-data-table>
			</v-tab-item><!--Vonalkódolvasó állomások-->
    </v-tabs>
		<template>
		  <v-row justify="center">
		    <v-dialog
		      v-model="dialogusok.torlesmegerosito.mutat"
		      persistent
		      max-width="600px"
		    > <!--Törlésmegerősítő-->

		      <v-card>
		        <v-card-title>
		          <span class="headline" v-if="dialogusok.torlesmegerosito.mutat">{{dialogusok.torlesmegerosito.mittorol ==0? "Felhasználó" : (dialogusok.torlesmegerosito.mittorol == 1 ? "Csoport" : (dialogusok.torlesmegerosito.mittorol==2 ? "Szoba" : (dialogusok.torlesmegerosito.mittorol==3 ? "Szilencium" : (dialogusok.torlesmegerosito.mittorol==4 ? "Minősítés": (dialogusok.torlesmegerosito.mittorol==5 ? "Szakkör" : (dialogusok.torlesmegerosito.mittorol==6 ? "Szobapontozási szempont" : (dialogusok.torlesmegerosito.mittorol==7 ? "Vonalkód" : (dialogusok.torlesmegerosito.mittorol==8?"Vonalkódolvasó-állomás":"Terem"))))))))}} törlése</span>
		        </v-card-title>
		        <v-card-text v-if="dialogusok.torlesmegerosito.mutat">
		          <v-container>
		            Biztos törli {{dialogusok.torlesmegerosito.mittorol ==0? (admin.felhasznalok.find(f => f.id==dialogusok.torlesmegerosito.id).nev+" felhasználót") : (dialogusok.torlesmegerosito.mittorol == 1 ? ("a(z) "+admin.csoportok.find(cs => cs.id==dialogusok.torlesmegerosito.id).csoportnev+" csoportot") : (dialogusok.torlesmegerosito.mittorol == 2 ? ("a(z) "+admin.szobak.find(sz => sz.id==dialogusok.torlesmegerosito.id).szobanev+" szobát") : (dialogusok.torlesmegerosito.mittorol==3 ? ("a(z) "+admin.szilenciumok.find(sz => sz.id==dialogusok.torlesmegerosito.id).szam+". szilenciumot") : (dialogusok.torlesmegerosito.mittorol==4 ? ("a(z) "+admin.minositesek.find(m => m.id==dialogusok.torlesmegerosito.id).minositesnev+" minősítést") : (dialogusok.torlesmegerosito.mittorol==5 ? ("a(z) "+admin.szakkorok.find(sz => sz.id==dialogusok.torlesmegerosito.id).szakkornev+" szakkört") : ( dialogusok.torlesmegerosito.mittorol == 6 ? ("a(z) "+admin.szobapontozasiszempontok.find(sz => sz.id==dialogusok.torlesmegerosito.id).szempont+" szempontot") : (dialogusok.torlesmegerosito.mittorol == 7 ? "a vonalkódot" : (dialogusok.torlesmegerosito.mittorol == 8 ?("a(z) "+admin.vonalkodolvasoallomasok.find(vka => vka.id==dialogusok.torlesmegerosito.id).allomasnev+" vonalkódolvasó-állomást") : (`a(z) ${admin.termek.find(t => t.id==dialogusok.torlesmegerosito.id).nev} termet`)))))))))}}?
		          </v-container>
		        </v-card-text>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn
		            color="blue darken-1"
		            text
		            @click="dialogusok.torlesmegerosito.mutat = false"
		          >
		            Mégsem<v-icon>fa-times</v-icon>
		          </v-btn>
		          <v-btn
		            color="red accent-4"
		            text
		            @click="torles()"
		          >
		            Törlés<v-icon>fa-trash</v-icon>
		          </v-btn>
		        </v-card-actions>
		      </v-card><!--Törlésmegerősítő-->
	    </v-dialog>
			<v-dialog
				v-model="dialogusok.jelszovaltoztato.mutat"
				persistent
				max-width="600px"
			> <!--Jelszóváltoztató-->

				<v-card>
					<v-card-title>
						<span class="headline" v-if="dialogusok.jelszovaltoztato.mutat">{{admin.felhasznalok.find(f => f.id==dialogusok.jelszovaltoztato.felhasznaloid).nev}} jelszavának módosítása</span>
					</v-card-title>
					<v-card-text>
						<v-container>
							<p>A felhasználó a megváltoztatott jelszóval emailt fog kapni</p>
							<v-text-field
								v-model="dialogusok.jelszovaltoztato.ujjelszo"
								label="Új jelszó"
								prepend-inner-icon="fa-key"
								:type="dialogusok.jelszovaltoztato.veletlenszerujelszo||dialogusok.jelszovaltoztato.ujjelszo=='A12345a' ? 'text' : 'password'"
								rounded
								outlined
							></v-text-field>
							<v-text-field
								v-model="dialogusok.jelszovaltoztato.ujjelszoismetles"
								label="Új jelszó ismétlése"
								prepend-inner-icon="fa-redo"
								:type="dialogusok.jelszovaltoztato.veletlenszerujelszo||dialogusok.jelszovaltoztato.ujjelszoismetles=='A12345a' ? 'text' : 'password'"
								rounded
								outlined
							></v-text-field>
							<v-checkbox v-model="dialogusok.jelszovaltoztato.veletlenszerujelszo" @click="() => {if(dialogusok.jelszovaltoztato.veletlenszerujelszo)veletlenszerujelszo(1); else {dialogusok.jelszovaltoztato.ujjelszo=''; dialogusok.jelszovaltoztato.ujjelszoismetles=''}}" label="Véletlenszerű jelszó"></v-checkbox>

						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogusok.jelszovaltoztato.veletlenszerujelszo=false, dialogusok.jelszovaltoztato.mutat = false, dialogusok.jelszovaltoztato.ujjelszo='', dialogusok.jelszovaltoztato.ujjelszoismetles=''"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							@click="jelszomodositas()"
							v-if="dialogusok.jelszovaltoztato.ujjelszo!=''&&dialogusok.jelszovaltoztato.ujjelszo==dialogusok.jelszovaltoztato.ujjelszoismetles"
						>
							Módosítás<v-icon>fa-save</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card><!--Jelszóváltoztató-->
			</v-dialog>
			<v-dialog
				v-model="dialogusok.ujfelhasznalo.mutat"
				persistent
				max-width="600px"
			> <!--Új felhasználó-->

				<v-card>
					<v-card-title>
						<span class="headline" v-if="dialogusok.ujfelhasznalo.mutat">Új felhasználó létrehozása</span>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-text-field
								v-model="dialogusok.ujfelhasznalo.nev"
								label="Név"
								prepend-inner-icon="fa-user"
								rounded
								outlined
							></v-text-field>
							<v-text-field
								v-model="dialogusok.ujfelhasznalo.email"
								label="Email-cím"
								prepend-inner-icon="fa-envelope"
								rounded
								outlined
							></v-text-field>
							<p>A felhasználó a jelszóval emailt fog kapni</p>
							<v-text-field
								v-model="dialogusok.ujfelhasznalo.jelszo"
								label="Jelszó"
								prepend-inner-icon="fa-key"
								:type="dialogusok.ujfelhasznalo.jelszo=='A12345a' || dialogusok.ujfelhasznalo.veletlenszerujelszo ? 'text' : 'password'"
								rounded
								outlined
								:readonly="dialogusok.ujfelhasznalo.veletlenszerujelszo"
							></v-text-field>
							<v-select
								v-model="dialogusok.ujfelhasznalo.minosites"
								label="Minősítés"
								prepend-inner-icon="fa-star"
								:items="admin.minositesek"
								item-text="minositesnev"
								item-value="id"
								rounded
								outlined
							></v-select>
							<v-checkbox v-model="dialogusok.ujfelhasznalo.tomegeshozzaadas" label="Tömeges hozzáadás"></v-checkbox>
							<v-checkbox v-model="dialogusok.ujfelhasznalo.veletlenszerujelszo" @click="() => {if(dialogusok.ujfelhasznalo.veletlenszerujelszo)veletlenszerujelszo(0); else dialogusok.ujfelhasznalo.jelszo='A12345a'}" label="Véletlenszerű jelszó"></v-checkbox>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogusok.ujfelhasznalo.mutat=false,dialogusok.ujfelhasznalo.jelszo='A12345a',dialogusok.ujfelhasznalo.veletlenszerujelszo=false,dialogusok.ujfelhasznalo.minosites=0,dialogusok.ujfelhasznalo.nev='',dialogusok.ujfelhasznalo.email='',dialogusok.ujfelhasznalo.tomegeshozzaadas=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							@click="ujfelhasznalo()"
							v-if="dialogusok.ujfelhasznalo.nev&&dialogusok.ujfelhasznalo.email&&dialogusok.ujfelhasznalo.jelszo&&dialogusok.ujfelhasznalo.minosites>=-2"
						>
							Létrehozás<v-icon>fa-user-plus</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card><!--Új felhasználó-->
			</v-dialog>
			<v-dialog
				v-model="dialogusok.felhasznalokimportalasa.mutat"
				persistent
				max-width="600px"
			> <!--Felhasználók importálása-->

				<v-card>
					<v-card-title>
						<span class="headline">Felhasználók importálása Excel táblázatból</span>
					</v-card-title>
					<v-card-text>
						<v-container>
							<v-file-input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" v-model="dialogusok.felhasznalokimportalasa.excelfajl" placeholder=".xlsx fájl( NÉV|EMAIL|JELSZÓ)"/>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogusok.felhasznalokimportalasa.mutat=false"
						>
							Mégsem<v-icon>fa-times</v-icon>
						</v-btn>
						<v-btn
							color="success"
							text
							@click="felhasznalokimportalasa()"
							v-if="dialogusok.felhasznalokimportalasa.excelfajl"
						>
							Importálás<v-icon>fa-file-import</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card><!--Új felhasználó-->
			</v-dialog>
			<v-dialog
					v-model="dialogusok.ujcsoport.mutat"
					persistent
					max-width="600px"
			><!--Új csoport-->

					<v-card>
						<v-card-title>
							<span class="headline" v-if="dialogusok.ujcsoport.mutat">Új csoport létrehozása</span>
						</v-card-title>
						<v-card-text>
							<v-container>
								<v-text-field
									v-model="dialogusok.ujcsoport.nev"
									label="Csoportnév"
									prepend-inner-icon="fa-users"
									rounded
									outlined
								></v-text-field>
								<v-select
									v-model="dialogusok.ujcsoport.csoportvezeto"
									label="Csoportvezető"
									prepend-inner-icon="fa-chalkboard-teacher"
									rounded
									outlined
									v-if="admin.felhasznalok"
									:items="admin.felhasznalok.filter(f=> f.minosites<0 && admin.csoportok.filter(cs => cs.csoportvezetoid==f.id).length==0)"
									item-text="nev"
									item-value="id"
								></v-select>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								color="blue darken-1"
								text
								@click="dialogusok.ujcsoport.mutat=false, dialogusok.ujcsoport.nev=''"
							>
								Mégsem<v-icon>fa-times</v-icon>
							</v-btn>
							<v-btn
								color="success"
								text
								@click="ujcsoport()"
								v-if="dialogusok.ujcsoport.nev!=''&&dialogusok.ujcsoport.csoportvezeto>-1"
							>
								Létrehozás<v-icon>fa-plus</v-icon>
							</v-btn>
						</v-card-actions>
					</v-card><!--Új csoport-->
			</v-dialog>
			<v-dialog
					v-model="dialogusok.ujszoba.mutat"
					persistent
					max-width="600px"
			><!--Új szoba-->

					<v-card>
						<v-card-title>
							<span class="headline" v-if="dialogusok.ujszoba.mutat">Új szoba létrehozása</span>
						</v-card-title>
						<v-card-text>
							<v-container>
								<v-text-field
									v-model="dialogusok.ujszoba.nev"
									label="Szobanév"
									prepend-inner-icon="fa-bed"
									rounded
									outlined
								></v-text-field>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
								color="blue darken-1"
								text
								@click="dialogusok.ujszoba.mutat=false, dialogusok.ujszoba.nev=''"
							>
								Mégsem<v-icon>fa-times</v-icon>
							</v-btn>
							<v-btn
								color="success"
								text
								@click="ujszoba()"
								v-if="dialogusok.ujszoba.nev!=''"
							>
								Létrehozás<v-icon>fa-plus</v-icon>
							</v-btn>
						</v-card-actions>
					</v-card><!--Új szoba-->
			</v-dialog>
	  </v-row>
		<v-snackbar
		 v-model="snackbar.megnyit"
		>
		 {{ snackbar.szoveg }}
		 <v-btn
			 color="pink"
			 text
			 @click="snackbar.megnyit = false"
		 >
			 Bezár
		 </v-btn>
		</v-snackbar>
	</template>

	</div>
</template>

<script>
	import router from '../router';
	export default {
		data: function(){
			return {
				admin: {},
        aktivtab: 0,
				Vfrissites: 0,
        tablazatok: {
          felhasznalok: {
            kereses: "",
            fejlec: [
              {
                text: "Név",
                value: "nev",
                align: 'center',
                sortable: true,
                groupable: false,
                filterable: true
              },
              {
                text: "E-mail",
                value: "email",
                align: 'center',
                sortable: false,
                filterable: true,
                groupable: false
              },
              {
                text: "Minősítés",
                value: "minosites",
                align: 'center',
                sortable: true,
                filterable: false,
                groupable: true
              },
							{
								text: "Csoport",
								value: "csoportid",
								align: "center",
								sortable: true,
								filterable: true,
								groupable: false
							},
							{
								text: "Szoba",
								value: "szobaid",
								align: "center",
								sortable: true,
								filterable: true,
								groupable: false
							},
							{
								text: "Vonalkód",
								value: "vonalkod",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							},
              {
                text: "Műveletek",
                value: "muveletek",
                align: "center",
                sortable: false,
                filterable: false,
                groupable: false
              }
            ]
          },
					csoportok: {
            kereses: "",
            fejlec: [
              {
                text: "Csoport",
                value: "csoportnev",
                align: 'center',
                sortable: true,
                groupable: false,
                filterable: false
              },
              {
                text: "Csoportvezető",
                value: "csoportvezeto",
                align: 'center',
                sortable: false,
                filterable: true,
                groupable: false
              },
							{
								text: "Létszám",
								value: "letszam",
								align: "center",
								sortable: true,
								filterable: false,
								groupable: false
							},
              {
                text: "Műveletek",
                value: "muveletek",
                align: "center",
                sortable: false,
                filterable: false,
                groupable: false
              }
            ]

					},
					szobak: {
						kereses: "",
						szobahoztanuloid: null,
						fejlec: [
							{
								text: "Szoba",
								value: "szobanev",
								align: 'center',
								sortable: true,
								groupable: false,
								filterable: true
							},
							{
								text: "Tanulók",
								value: "tanulok",
								align: 'center',
								sortable: false,
								filterable: true,
								groupable: false
							},
							{
								text: "Létszám",
								value: "letszam",
								align: "center",
								sortable: true,
								filterable: false,
								groupable: false
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							}
						]

          },
					szilenciumok: {
						termek: {
							key: 0,
							fejlec: [
								{
									text: "Név",
									value: "nev",
									align: 'center',
									sortable: false,
									groupable: false,
									filterable: false
								},
								{
									text: "Férőhely",
									value: "ferohely",
									align: 'center',
									sortable: false,
									groupable: false,
									filterable: false
								},
								{
									text: "Műveletek",
									value: "muveletek",
									align: 'center',
									sortable: false,
									groupable: false,
									filterable: false
								}

							]
						},
						fejlec: [
							{
								text: "Szám",
								value: "szam",
								align: 'center',
								sortable: true,
								groupable: false,
								filterable: false
							},
							{
								text: "Időpont",
								value: "idopont",
								align: 'center',
								sortable: false,
								filterable: false,
								groupable: false
							},
							{
								text: "Létszámkorlát",
								value: "letszamkorlat",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							}
						]

          },
					termek: {
						fejlec: [
							{
								text: "Név",
								value: "nev",
								align: 'center',
								sortable: true,
								groupable: false,
								filterable: false
							},
							{
								text: "Férőhely",
								value: "ferohely",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							}
						]

					},

					minositesek: {
						fejlec: [
							{
								text: "Minősítés",
								value: "minositesnev",
								align: 'center',
								sortable: true,
								groupable: false,
								filterable: false
							},
							{
								text: "Létszám",
								value: "letszam",
								align: "center",
								sortable: false,
								groupable: false,
								filterable: false
							},
							{
								text: "Szilenciumválasztásra kötelezett",
								value: "szilenciumvalasztas",
								align: 'left',
								sortable: false,
								filterable: false,
								groupable: false
							},
							{
								text: "Szilenciumi létszámba számító(tanulószoba)",
								value: "szilenciumiletszambaszamit",
								align: "left",
								sortable: false,
								filterable: false,
								groupable: false
							},
							{
								text: "Minimum választandó szilencium",
								value: "valasztandoszilencium",
								align: "left",
								sortable: false,
								filterable: false,
								groupable: false
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							}
						]

          },
					szakkorok: {
						fejlec: [
							{
								text: "Szakkör",
								value: "szakkornev",
								align: 'center',
								sortable: true,
								groupable: false,
								filterable: false
							},
							{
								text: "Szakkörvezető",
								value: "szakkorvezeto",
								align: "center",
								sortable: false,
								groupable: false,
								filterable: false
							},
							{
								text: "Időpontja és helye",
								value: "idoponteshely",
								align: "center",
								sortable: true,
								groupable: false,
								filterable: false
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							}
						]
					},
					szobapontozasiszempontok: {
						pontmodositas: false,
						fejlec: [
							{
								text: "Szempont",
								value: "szempont",
								align: "center",
								sortable: true,
								filterable: true,
								groupable: false
							},
							{
								text: "Leírás",
								value: "leiras",
								align: "center",
								sortable: true,
								filterable: true,
								groupable: false
							},
							{
								text: "Pont",
								value: "pont",
								align: "center",
								sortable: true,
								filterable: false,
								groupable: false
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							},

						]
					},
					vonalkodok: {
						kereses: "",
						fejlec: [
							{
								text: "Vonalkód",
								value: "vonalkod",
								align: "center",
								sortable: true,
								filterable: true,
								groupable: false
							},
							{
								text: "Tanuló",
								value: "tanulo",
								align: "center",
								sortable: true,
								filterable: true,
								groupable: true
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							},

						]
					},
					vonalkodolvasoallomasok: {
						fejlec: [
							{
								text: "Állomásnév",
								value: "allomasnev",
								align: "center",
								sortable: true,
								filterable: true,
								groupable: false
							},
							{
								text: "Feladat",
								value: "feladat",
								align: "center",
								sortable: false,
								filterable: true,
								groupable: false
							},
							{
								text: "Műveletek",
								value: "muveletek",
								align: "center",
								sortable: false,
								filterable: false,
								groupable: false
							},

						]
					}

        },
        dialogusok: {
          torlesmegerosito: {
            mittorol: 0, //0: felhasználó, 1: csoport, 2: szoba, 3: szilencium, 4: minősítés,
            id: 0,
            mutat: false,
						megerositesnelkul: false
          },
					jelszovaltoztato: {
						felhasznaloid: -1,
						ujjelszo: "",
						ujjelszoismetles: "",
						mutat: false,
						veletlenszerujelszo: false
					},
					ujfelhasznalo: {
						tomegeshozzaadas: false,
						nev: "",
						email: "",
						jelszo: "A12345a",
						veletlenszerujelszo: false,
						minosites: 0,
						mutat: false
					},
					felhasznalokimportalasa: {
						mutat: false,
						excelfajl: null
					},
					ujcsoport: {
						nev: "",
						csoportvezeto: -1,
						mutat: false
					},
					ujszoba: {
						nev:"",
						mutat: false
					},
					ujszilencium: {
						szam: "",
						idopont:"",
						letszamkorlat: 25
					},
					teremHozzarendeleseSzilenciumhoz: {
						teremid: null
					},

					ujterem: {
						nev: "",
						ferohely: 0
					},
					ujminosites: {
						minositesnev: "",
						szilenciumvalasztas: 0,
						szilenciumiletszambaszamit: 0,
						valasztandoszilencium: 3
					},
					ujszakkor: {
						szakkornev: "",
						szakkorvezetoid: -1,
						idoponteshely: ""
					},
					ujszobapontozasiszempont: {
						szempont: "",
						leiras: "",
						pont: 0
					},
					ujvonalkod: {
						vonalkod: "",
						tanuloid: -1
					},
					ujvonalkodolvasoallomas: {
						allomasnev: ""
					}
        },
        snackbar: {
          megnyit: false,
          szoveg: ""
        },
				modositottertek: ""
			}
		},
		computed: {

		},
		watch: {

		},
		methods: {
			ujtitkoskulcs: function(vonalkodolvasoallomasid) {
				this.axios.post(this.$store.state.backendeleres+"admin/ujtitkoskulcs",{vonalkodolvasoallomasid})
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										this.snackbar.szoveg=response.data.ok ? "Új titkos kulcs generálása sikesen megtörtént!" : ("Új titkos kulcs generálása hibába ütközött: "+response.data.hiba)
										this.snackbar.megnyit=true;
									})
			},
			ujvonalkodolvasoallomas: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujvonalkodolvasoallomas",this.dialogusok.ujvonalkodolvasoallomas)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes()
										if(response.data.ok) {
											this.admin.vonalkodolvasoallomasok.push({id: response.data.id, ...this.dialogusok.ujvonalkodolvasoallomas, feladat: -1})
											this.dialogusok.ujvonalkodolvasoallomas.allomasnev=""
										}
										this.snackbar.szoveg=response.data.ok ? "A vonalkódolvasó-állomás hozzáadása sikeresen megtörtént!" : ("A vonalkódolvasó-állomás hozzáadása hibába ütközött: "+response.data.hiba)
										this.snackbar.megnyit=true;
									})
			},
			ujvonalkod: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujvonalkod",this.dialogusok.ujvonalkod)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes;
										if(response.data.ok) {
											this.admin.vonalkodok.push({...this.dialogusok.ujvonalkod})
											this.dialogusok.ujvonalkod.vonalkod="";
										}
										this.snackbar.szoveg=response.data.ok ? "A vonalkód hozzáadása sikeresen megtörtént!" : ("A vonalkód hozzáadása hibába ütközött: "+response.data.hiba)
										this.snackbar.megnyit=true;
									})
			},
			ujszobapontozasiszempont: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujszobapontozasiszempont",this.dialogusok.ujszobapontozasiszempont)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.szobapontozasiszempontok.push({...this.dialogusok.ujszobapontozasiszempont, id: response.data.id})
											this.dialogusok.ujszobapontozasiszempont.szempont="";
											this.dialogusok.ujszobapontozasiszempont.leiras="";
											this.dialogusok.ujszobapontozasiszempont.pont=0;
											this.snackbar.szoveg="A szempont hozzáadása megtörtént";
											this.snackbar.megnyit=true;
										}
										else{
											this.snackbar.szoveg="A szempont hozzáadása nem sikerült: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			ujszakkor: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujszakkor",this.dialogusok.ujszakkor)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.szakkorok.push({...this.dialogusok.ujszakkor, id: response.data.id})
											this.dialogusok.ujszakkor.szakkornev="";
											this.dialogusok.ujszakkor.idoponteshely="";
											this.snackbar.szoveg="A szakkör hozzáadása megtörtént";
											this.snackbar.megnyit=true;
										}
										else{
											this.snackbar.szoveg="A szakkör hozzáadása nem sikerült: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			ujminosites: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujminosites",this.dialogusok.ujminosites)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.minositesek.push({...this.dialogusok.ujminosites, id: response.data.id})
											this.dialogusok.ujminosites.minositesnev="";
											this.snackbar.szoveg="A minősítés hozzáadása megtörtént";
											this.snackbar.megnyit=true;
										}
										else{
											this.snackbar.szoveg="A minősítés hozzáadása nem sikerült: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			ujszilencium: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujszilencium",this.dialogusok.ujszilencium)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.szilenciumok.push({...this.dialogusok.ujszilencium, id: response.data.id})
											this.dialogusok.ujszilencium.szam=""; this.dialogusok.ujszilencium.idopont=""; this.dialogusok.ujszilencium.letszamkorlat=25
											this.snackbar.szoveg="A szilencium hozzáadása megtörtént";
											this.snackbar.megnyit=true;
										}
										else{
											this.snackbar.szoveg="A szilencium hozzáadása nem sikerült: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			teremHozzarendeleseSzilenciumhoz: function(teremid, szilenciumid) {
				this.axios.post(`${this.$store.state.backendeleres}admin/teremHozzarendeleseSzilenciumhoz`, {teremid, szilenciumid}).then(response => {
					if(response.data.bejelentkezve==false) this.kijelentkezes();
					if(response.data.ok) {
						const terem = this.admin.termek.find(t => t.id==teremid);
						this.admin.terem_szilencium.push({teremid, szilenciumid})
						this.admin.szilenciumok.find(sz => sz.id==szilenciumid).termek.push(terem);
						this.snackbar.szoveg="A hozzáadás sikeresen megtörtént";
						this.snackbar.megnyit=true;
						this.tablazatok.szilenciumok.termek.key++;
						this.dialogusok.teremHozzarendeleseSzilenciumhoz.teremid=null
					}
					else{
						this.snackbar.szoveg="A hozzárendelés nem sikerült: "+response.data.hiba;
						this.snackbar.megnyit=true;
					}
				})
			},
			teremTorleseSzilenciumtol: function(teremid, szilenciumid) {
				this.axios.post(`${this.$store.state.backendeleres}admin/teremTorleseSzilenciumtol`, {teremid, szilenciumid}).then(response => {
					if(response.data.bejelentkezve==false) this.kijelentkezes();
					if(response.data.ok) {
						const szilo = this.admin.szilenciumok.find(sz => sz.id==szilenciumid);
						szilo.termek.splice(szilo.termek.findIndex(t => t.id==teremid),1);
						this.admin.terem_szilencium.splice(this.admin.terem_szilencium.findIndex(tsz => tsz.szilenciumid==szilenciumid&&tsz.teremid==teremid),1)
						this.snackbar.szoveg="A törlés sikeresen megtörtént";
						this.snackbar.megnyit=true;
						this.tablazatok.szilenciumok.termek.key++;
					}
					else{
						this.snackbar.szoveg="A törlés nem sikerült: "+response.data.hiba;
						this.snackbar.megnyit=true;
					}
				})
			},
			ujterem: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujterem",this.dialogusok.ujterem)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.termek.push({...this.dialogusok.ujterem, id: response.data.id})
											this.dialogusok.ujterem.nev=""; this.dialogusok.ujterem.ferohely="";
											this.snackbar.szoveg="A terem hozzáadása megtörtént";
											this.snackbar.megnyit=true;
										}
										else{
											this.snackbar.szoveg="A terem hozzáadása nem sikerült: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})

			},
			szobaboltorles: function(tanuloid){
				this.axios.delete(this.$store.state.backendeleres+"admin/szobaboltorles/"+tanuloid)
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.felhasznalok.find(f => f.id==tanuloid).szobaid=null
											this.frissites();
											this.snackbar.szoveg="A szobából tanuló törlése sikeresen megtörtént.";
											this.snackbar.megnyit=true;
										}
										else{
											this.snackbar.szoveg="A szobából tanuló törlése hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			szobahozrendeles: function(felhasznaloid,szobaid) {
				this.axios.post(this.$store.state.backendeleres+"admin/szobahozrendeles",{felhasznaloid,szobaid})
									.then((response) => {
										if(response.data.bejelntkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.felhasznalok.find(f => f.id==felhasznaloid).szobaid=szobaid;
											this.snackbar.szoveg="A szobához rendelés sikeresen megtörtént.";
											this.snackbar.megnyit=true;
											this.frissites();
										}
										else{
											this.snackbar.szoveg="A szobához rendelés hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			ujszoba: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujszoba",{szobanev: this.dialogusok.ujszoba.nev})
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.dialogusok.ujszoba.mutat=false;
											this.admin.szobak.push({id: response.data.id, szobanev: this.dialogusok.ujszoba.nev})
										}
										else{
											this.snackbar.szoveg="A létrehozás hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			csoporthozrendeles: function(felhasznaloid,csoportid) {
				this.axios.post(this.$store.state.backendeleres+"admin/csoporthozrendeles", {felhasznaloid, csoportid})
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.felhasznalok.find(f => f.id==felhasznaloid).csoportid=csoportid;
											this.snackbar.szoveg="A csoporthoz rendelés sikeresen megtörtént.";
											this.snackbar.megnyit=true;
										}
										else{
											this.snackbar.szoveg="A csoporthoz rendelés hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			ujcsoport: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujcsoport",{csoportnev: this.dialogusok.ujcsoport.nev, csoportvezeto: this.dialogusok.ujcsoport.csoportvezeto})
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.admin.csoportok.push({csoportnev: this.dialogusok.ujcsoport.nev, csoportvezetoid: this.dialogusok.ujcsoport.csoportvezeto, id: response.data.id});
											this.dialogusok.ujcsoport.mutat=false;
											this.dialogusok.ujcsoport.nev=false;
											this.dialogusok.ujcsoport.csoportvezeto=-1
										}
										else{
											this.snackbar.szoveg="A létrehozás hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			felhasznalokimportalasa: function() {
				var formData = new FormData();
	      formData.append('felhasznalok', this.dialogusok.felhasznalokimportalasa.excelfajl);
	      this.axios.post(this.$store.state.backendeleres+"tablazatimportalas/felhasznalok",
	          formData,
	          {
	            headers: {
	                'Content-Type': 'multipart/form-data'
	            }
	          }
	        ).then((response) => {
						if(response.data.ok) {
							this.$forceUpdate()
						}
	        })
			},
			ujfelhasznalo: function() {
				this.axios.post(this.$store.state.backendeleres+"admin/ujfelhasznalo",{nev: this.dialogusok.ujfelhasznalo.nev, email: this.dialogusok.ujfelhasznalo.email, jelszo: this.dialogusok.ujfelhasznalo.jelszo, minosites: this.dialogusok.ujfelhasznalo.minosites})
									.then((response) => {
										if(response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok){
											this.admin.felhasznalok.push({id: response.data.id, nev: this.dialogusok.ujfelhasznalo.nev, email: this.dialogusok.ujfelhasznalo.email, minosites: this.dialogusok.ujfelhasznalo.minosites})
											this.dialogusok.ujfelhasznalo.mutat=this.dialogusok.ujfelhasznalo.tomegeshozzaadas;
											this.dialogusok.ujfelhasznalo.nev=""
											this.dialogusok.ujfelhasznalo.email=""
											if(this.dialogusok.ujfelhasznalo.veletlenszerujelszo) this.veletlenszerujelszo(0);
											else this.dialogusok.ujfelhasznalo.jelszo="A12345a";
											this.dialogusok.ujfelhasznalo.minosites=0
										}
										else {
											this.snackbar.szoveg="A létrehozás hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			jelszomodositas: function() {
				if(this.dialogusok.jelszovaltoztato.ujjelszo==this.dialogusok.jelszovaltoztato.ujjelszoismetles&&this.dialogusok.jelszovaltoztato.ujjelszo!=""){
					this.axios.post(this.$store.state.backendeleres+"admin/jelszomodositas",{ujjelszo: this.dialogusok.jelszovaltoztato.ujjelszo, id: this.dialogusok.jelszovaltoztato.felhasznaloid})
										.then((response) => {
											if (response.data.bejelentkezve==false) this.kijelentkezes();
											if(response.data.ok) {
												this.snackbar.szoveg="A módosítás sikeresen megtörtént.";
												this.snackbar.megnyit=true;
												this.dialogusok.jelszovaltoztato.felhasznaloid=-1
												this.dialogusok.jelszovaltoztato.ujjelszo="";
												this.dialogusok.jelszovaltoztato.ujjelszoismetles="";
												this.dialogusok.jelszovaltoztato.mutat=false;
												this.dialogusok.jelszovaltoztato.veletlenszerujelszo=false
											}
											else {
												this.snackbar.szoveg="A módosítás hibába ütközött: "+response.data.hiba;
												this.snackbar.megnyit=true;
											}
										})
				}
			},
			modositas: function(mitmodosit,id,modositandotul) {
				this.axios.post(this.$store.state.backendeleres+"admin/modositas",{mitmodosit, id, modositandotul, modositottertek: this.modositottertek })
									.then((response) => {
										if (response.data.bejelentkezve==false) this.kijelentkezes();
										if(response.data.ok) {
											this.snackbar.szoveg="A módosítás sikeresen megtörtént.";
											this.snackbar.megnyit=true;
											switch(mitmodosit) {
												case 0: //Felhasználó
													var felhasznalo = this.admin.felhasznalok.find(f => f.id==id);
													if(modositandotul==0) felhasznalo.nev=this.modositottertek;
													else if(modositandotul==1) felhasznalo.email=this.modositottertek;
													else if(modositandotul==2) felhasznalo.minosites=this.modositottertek;
												break
												case 1:
													var csoport = this.admin.csoportok.find(cs => cs.id==id);
													if(modositandotul==0) csoport.csoportnev=this.modositottertek;
													else if(modositandotul==1) csoport.csoportvezetoid=this.modositottertek
												break;
												case 2:
													var szoba = this.admin.szobak.find(sz => sz.id==id)
													if(modositandotul==0) szoba.szobanev=this.modositottertek
												break;
												case 3:
													var szilencium=this.admin.szilenciumok.find(sz => sz.id==id)
													if(modositandotul==0) szilencium.szam=this.modositottertek
													else if(modositandotul==1) szilencium.idopont=this.modositottertek
													else if(modositandotul==2) szilencium.letszamkorlat=this.modositottertek
												break;
												case 4:
													var minosites = this.admin.minositesek.find(m => m.id==id);
													if(modositandotul==0) minosites.minositesnev=this.modositottertek
													else if(modositandotul==1) minosites.szilenciumvalasztas=this.modositottertek;
													else if(modositandotul==2) minosites.szilenciumiletszambaszamit=this.modositottertek;
													else if(modositandotul==3) minosites.valasztandoszilencium=this.modositottertek;
												break;
												case 5:
													var szakkor = this.admin.szakkorok.find(sz => sz.id==id);
													if(modositandotul==0) szakkor.szakkornev=this.modositottertek;
													else if(modositandotul==1) szakkor.szakkorvezetoid=this.modositottertek;
													else if(modositandotul==2) szakkor.idoponteshely=this.modositottertek;
												break;
												case 6:
													var szobapontozasiszempont=this.admin.szobapontozasiszempontok.find(sz => sz.id==id);
													if(modositandotul==0) szobapontozasiszempont.szempont=this.modositottertek;
													else if (modositandotul==1) szobapontozasiszempont.leiras=this.modositottertek;
													else if (modositandotul==2) szobapontozasiszempont.pont=this.modositottertek;
												break;
											}
										}
										else {
											this.snackbar.szoveg="A módosítás hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
									})
			},
			torlesdialogus: function(mittorol,id) {
				this.dialogusok.torlesmegerosito.mittorol=mittorol;
				this.dialogusok.torlesmegerosito.id=id;
				this.dialogusok.torlesmegerosito.mutat=!this.dialogusok.torlesmegerosito.megerositesnelkul;
				if(this.dialogusok.torlesmegerosito.megerositesnelkul) this.torles();
			},
			torles: function () {
				this.axios.delete(this.$store.state.backendeleres+"admin/torles/"+this.dialogusok.torlesmegerosito.mittorol+"/"+this.dialogusok.torlesmegerosito.id)
									.then((response) => {
										if(response.data.ok) {
											switch(this.dialogusok.torlesmegerosito.mittorol) {
												case 0: //Felhasználó
													this.admin.felhasznalok.splice(this.admin.felhasznalok.findIndex(f => f.id==this.dialogusok.torlesmegerosito.id),1)
												break;
												case 1: //csoport
													this.admin.csoportok.splice(this.admin.csoportok.findIndex(cs => cs.id==this.dialogusok.torlesmegerosito.id),1)
													this.admin.felhasznalok.filter(f=>f.csoportid==this.dialogusok.torlesmegerosito.id).forEach(f=> f.csoportid=null)
												break;
												case 2: //szoba
													this.admin.szobak.splice(this.admin.szobak.findIndex(sz => sz.id==this.dialogusok.torlesmegerosito.id),1)
													this.admin.felhasznalok.filter(f=>f.szobaid==this.dialogusok.torlesmegerosito.id).forEach(f=> f.szobaid=null)
												break;
												case 3: //szilencium
													this.admin.szilenciumok.splice(this.admin.szilenciumok.findIndex(sz => sz.id==this.dialogusok.torlesmegerosito.id),1)
												break;
												case 4: //minosites
													this.admin.minositesek.splice(this.admin.minositesek.findIndex(m => m.id==this.dialogusok.torlesmegerosito.id),1)
												break;
												case 5: //szakkor
													this.admin.szakkorok.splice(this.admin.szakkorok.findIndex(sz => sz.id==this.dialogusok.torlesmegerosito.id),1)
												break;
												case 6: //Szobapontozási szempont
													this.admin.szobapontozasiszempontok.splice(this.admin.szobapontozasiszempontok.findIndex(sz => sz.id==this.dialogusok.torlesmegerosito.id),1)
												break;
												case 7: //vonalkód
													this.admin.vonalkodok.splice(this.admin.vonalkodok.findIndex(vk => vk.vonalkod==this.dialogusok.torlesmegerosito.id),1)
												break;
												case 8: //Vonalkódolvasóállomások
													this.admin.vonalkodolvasoallomasok.splice(this.admin.vonalkodolvasoallomasok.findIndex(vka => vka.id==this.dialogusok.torlesmegerosito.id),1)
												break;
												case 9: //Termek
													this.admin.termek.splice(this.admin.termek.findIndex(t => t.id==this.dialogusok.torlesmegerosito.id),1)
												break;
											}
											this.dialogusok.torlesmegerosito.mutat=false;
											this.snackbar.szoveg="A törlés sikeresen megtörtént."
											this.snackbar.megnyit=true;
										}
										else {
											this.snackbar.szoveg="A törlés hibába ütközött: "+response.data.hiba;
											this.snackbar.megnyit=true;
										}
										if (response.data.bejelentkezve==false) this.kijelentkezes();
									})
			},
			veletlenszerujelszo: function(mezo)  {
				var hossz = 8,
		        karakterek = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
		        jelszo = "";
		    for (var i = 0, n = karakterek.length; i < hossz; ++i) {
		        jelszo += karakterek.charAt(Math.floor(Math.random() * n));
		    }
				switch(mezo){
					case 0:
						this.dialogusok.ujfelhasznalo.jelszo=jelszo;
					break;
					case 1:
						this.dialogusok.jelszovaltoztato.ujjelszo=jelszo;
						this.dialogusok.jelszovaltoztato.ujjelszoismetles=jelszo;
					break;
				}
			},
			frissites: function() {if(this.Vfrissites) this.Vfrissites--; else this.Vfrissites++}
		},
		mounted(){
			this.axios.get(this.$store.state.backendeleres+"admin").then((response) => {
				if(response.data.ok){
          this.admin=response.data.admin;
					this.admin.szilenciumok.forEach(sz => {
						sz.termek = [];
						const osszerendelesek = this.admin.terem_szilencium.filter(tsz => tsz.szilenciumid==sz.id);
						osszerendelesek.forEach(o => {
							var t = {};
							t.id=o.teremid;
							const terem = this.admin.termek.find(_t => _t.id==o.teremid);
							t.nev = terem.nev;
							t.ferohely=terem.ferohely;
							sz.termek.push(t)
						})
					})
				}
        if(response.data.bejelentkezve== false) this.kijelentkezes();
			})
		}
	}
</script>
